<div class="checkout-header">
  <div class="top-info">
    <h5 class="top-head">{{ name }}</h5>
    <p class="smallest estimated">
      Est. Total:<sub class="currency">$</sub>
      <span>
        <h4>{{ totalCorrectNum }}.</h4>
        <p class="price-fractions smallest text-bold">{{ totalFractions }}</p>
      </span>
    </p>
  </div>
  <hr/>
</div>
